import classNames from 'classnames';
import { ReactNode, useEffect, useState } from 'react';
import { AriaLabel } from 'utilities/aria-types.js';
import { useMeasure } from 'utilities/hooks/use-measure.js';
import { FlexDivCenteredIcon } from 'utilities/svg-display/svg-layout.js';

interface IProps {
  title?: string;
  isAccordion?: boolean;
  children?: ReactNode;
}

export const InformationDropdown = ({ title = 'Information', isAccordion, children }: IProps) => {
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState('0px');
  const [ref, bounds] = useMeasure<HTMLDivElement>();

  const toggleOpen = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const updateHeight = () => {
      setHeight(open ? `${bounds.height}px` : '0px');
    };
    updateHeight();
  }, [open, bounds]);

  return (
    <div className="MoreInformation">
      <div
        aria-label={open ? AriaLabel.clickClose : AriaLabel.clickExpand}
        className={classNames(
          'MoreInformation__header',
          {
            'MoreInformation__header--accordion': isAccordion,
            'MoreInformation__header--open': open,
          },
          'u-flex u-flexAlignItemsCenter',
        )}
        role="button"
        onClick={toggleOpen}
      >
        <span className="u-flex u-flexAlignItemsCenter">
          <FlexDivCenteredIcon icon="info" size={23} />
          <span className="u-mL-xxs u-textBold u-text-xs">{title}</span>
        </span>
        <FlexDivCenteredIcon icon={`chevron-${open ? 'up' : 'down'}`} size={20} />
      </div>
      <div
        className={classNames('MoreInformation__content-wrapper', {
          'MoreInformation__content-wrapper--accordion': isAccordion,
        })}
        style={{ height }}
      >
        <div ref={ref} style={{ overflow: 'hidden' }}>
          <div
            className={classNames('MoreInformation__content MoreInformation__text', {
              'MoreInformation__content--accordion': isAccordion,
            })}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
